const usermodel=
    {
        CreationTime:'',
        Id:'',
        Name:'',
        Number:'',
        Remark:'',
        State:'',
        StateName:'',
        TenancyId:'',
        DreamToken:'',
        UserLevel:'',
        SkinVersion:'',
    
    }
const routerState=false;


export { usermodel,routerState };


// WEBPACK FOOTER //
// ./src/model/models.js